module.exports = __webpack_public_path__ + "static/media/service-ac-citra-raya-5.6d95edd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/service-ac-citra-raya-5.mp4
// module id = m3CU
// module chunks = 0